<mat-form-field>
  <mat-label>Reminder type</mat-label>
  <mat-select [formControl]="ngControl.control" [placeholder]=placeholder>
    @if (hasEmptyOption) {
      <mat-option [value]="false">All</mat-option>
    }
    <mat-option [value]="types.APPOINTMENT">{{ types[types.APPOINTMENT] | translate }}</mat-option>
    <mat-option [value]="types.COMPLIANCE">{{ types[types.COMPLIANCE] | translate }}</mat-option>
    <mat-option [value]="types.DOCUMENT_EXPIRY">{{ types[types.DOCUMENT_EXPIRY] | translate }}</mat-option>
    <mat-option [value]="types.FAMILY_OR_PERSONAL">{{ types[types.FAMILY_OR_PERSONAL] | translate }}</mat-option>
    <mat-option [value]="types.FINANCIAL_REVIEW">{{ types[types.FINANCIAL_REVIEW] | translate }}</mat-option>
    <mat-option [value]="types.INSURANCE_RENEWAL">{{ types[types.INSURANCE_RENEWAL] | translate }}</mat-option>
    <mat-option [value]="types.CONTRACT_EXPIRY">{{ types[types.CONTRACT_EXPIRY] | translate }}</mat-option>
    <mat-option [value]="types.LICENCE_RENEWAL">{{ types[types.LICENCE_RENEWAL] | translate }}</mat-option>
    <mat-option [value]="types.SERVICE">{{ types[types.SERVICE] | translate }}</mat-option>
    <mat-option [value]="types.OTHER">{{ types[types.OTHER] | translate }}</mat-option>
  </mat-select>
  <mat-error>
    <app-validation-error [errors]="ngControl.errors"></app-validation-error>
  </mat-error>
</mat-form-field>
